import React from 'react';

import Horizon from 'src/models/tract_detail/Horizon';

import PagedDropdown from 'src/components/controls/PagedDropdown';
import { SelectItem } from 'src/models/common/SelectItem';
import FormRow from 'src/components/controls/forms/FormRow';
import { HorizonInterval, Formation } from 'src/models/Horizon';
import Button from 'src/components/controls/forms/redesign/FormButton';
import DialogList from 'src/dialogs';
import TractDetail from 'src/models/tract_detail/TractDetail';

import CreateHorizonDto from 'src/models/tract_detail/CreateHorizonDto';
import CloneHorizon from 'src/models/CloneHorizon';
import { ITableConfig } from 'src/components/common/table';

export interface IHorizonSectionProps {
    horizons: Array<Horizon>;
    horizonNumber: number;
    uniqueHorizonIntervals: Array<HorizonInterval>;
    currentTract: TractDetail;
    currentClientNumber: number;
    currentProjectNumber: number;
    selectedHorizon: Horizon;
    formations: Array<Formation>;
    cloneHorizonData: CloneHorizon;
    idVerificationMessage: string;
    idVerificationResult: boolean;
    isFromChild?: boolean;
    unsavedChanges?: boolean;

    onChangeHorizon: (horizonId: number) => void;
    onGetData: (data: CloneHorizon) => void;
    onCreateHorizon: (horizon: CreateHorizonDto) => void;
    onCreateFormation: (formation: Formation) => void;
    showDialog: (dialog: string) => void;
    sequenceHorizons: (sequence: Array<{ id: number; sequence: number }>) => void;
    initializeOwnershipList: (config: ITableConfig) => void;
    setVerificationMessage: (message: string) => void;
    verifyId: (context: string, id: string) => void;
    navigate: (path: string) => void;
    updateTractAndHorizons?: (tractId: number, horizonNumber: number) => void;
    onOpenHorizonDialog: (dialogParams: IHorizonSectionProps) => void;
}

const HorizonSection = (props: IHorizonSectionProps) => {
    const horizonsItems = () => {
        if (!props.horizons || props.horizons.length === 0) {
            return undefined;
        }

        return props.horizons.map(
            (horizon: Horizon, index: number) =>
                new SelectItem(horizon.id, `Horizon ${horizon.horizonInterval.horizonNumber} (${index + 1} of ${props.horizons.length})`)
        );
    };

    const horizonDescription = () => {
        let hi = '';
        let showBadge = false;

        const badgeStyle: React.CSSProperties = {
            fontSize: '.8em',
            padding: '.1rem .5rem',
            background: '#00BF00',
            border: '1px solid #008000',
            marginLeft: '.5rem',
            borderRadius: '.3rem',
            marginRight: '.5rem',
            position: 'relative',
            fontWeight: 'bold',
            color: 'white',
        };

        if (props.selectedHorizon && props.selectedHorizon.horizonInterval) {
            hi = HorizonInterval.from(props.selectedHorizon.horizonInterval).toString();
        }

        if (props.selectedHorizon && props.selectedHorizon.horizonInterval.isTargetHorizon) {
            showBadge = true;
        }

        return (
            <span style={{ position: 'relative', top: '.6rem' }}>
                <span style={{ fontWeight: 'bold' }}>Horizon Definition: </span>
                {showBadge && <span style={badgeStyle}>Target Horizon</span>}
                {hi}
            </span>
        );
    };

    const changeHorizonHandler = (item: SelectItem) => {
        props.onChangeHorizon(item.id as number);
        props.initializeOwnershipList(null);
    };

    const onHorizonSelected = (dialogName: string) => {
        if (!!props.updateTractAndHorizons) {
            props.updateTractAndHorizons(props.selectedHorizon.tractId, props.selectedHorizon.horizonInterval.horizonNumber);
        }

        props.showDialog(dialogName);
    };

    const actionButtons = () => {
        return (
            <div style={{ position: 'absolute', top: '3.5rem', right: '1.2rem' }}>
                {props.unsavedChanges && (<div>Please save changes before updating the horizon.</div>)}
                <Button 
                    size="small" 
                    intent="primary horizon-add" 
                    text="Edit Horizon" 
                    onClick={() => onHorizonSelected(DialogList.EDIT_HORIZON)}
                    disabled={props.unsavedChanges}     
                />
                &nbsp;&nbsp;
                <Button
                    size="small"
                    intent="primary horizon-add"
                    text="Delete Horizon"
                    onClick={() => onHorizonSelected(DialogList.DELETE_HORIZON)}
                    disabled={(props.horizons && props.horizons.length === 1) || props.unsavedChanges}
                />
                &nbsp;&nbsp;
                <Button
                    size="small"
                    intent="primary horizon-add"
                    text="Sequence Horizons"
                    onClick={() => onHorizonSelected(DialogList.SEQUENCE_HORIZONS)}
                    disabled={props.unsavedChanges}
                />
                <Button
                    size="small"
                    intent="primary horizon-add"
                    text="Sequence Section"
                    onClick={() =>
                        props.navigate(
                            `/clients/${props.currentClientNumber}/projects/${props.currentProjectNumber}/sections/${props.currentTract.section}/section-horizon-sequence`
                        )
                    }
                    style={{ marginLeft: '.5rem', display: 'none' }}
                    disabled={props.unsavedChanges}
                />
                <span
                    style={{
                        display: 'inline-block',
                        height: '2.5rem',
                        width: '.2rem',
                        backgroundColor: 'darkgrey',
                        margin: '0 .5rem',
                        position: 'relative',
                        top: '.8rem',
                    }}
                />
                <Button size="small" intent="primary horizon-add" text="Create Horizon" onClick={() => props.onOpenHorizonDialog(props)} disabled={props.unsavedChanges}/>
            </div>
        );
    };

    return (
        <>
            <div className="dlc-tract-horizon-panel" style={{ position: 'relative', width: '100%' }}>
                <fieldset style={{ padding: '.3rem 0 .8rem 0', borderWidth: '1px 0 0 0' }}>
                    <legend className="legend">Horizon Information</legend>
                </fieldset>
                <FormRow>
                    <PagedDropdown
                        value={props.selectedHorizon ? props.selectedHorizon.id : 0}
                        size="small"
                        items={horizonsItems()}
                        onChange={changeHorizonHandler}
                    />
                </FormRow>
                {actionButtons()}
                {horizonDescription()}
            </div>
        </>
    );
};

export default HorizonSection;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/HorizonSection.tsx